import { useState } from 'react';
import '../styles/Checkout.css'; // Optional: Create CSS for the checkout page

const Checkout = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    city: '',
    zipCode: '',
    paymentMethod: 'credit',
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // Add checkout logic here
      await new Promise(resolve => setTimeout(resolve, 1000));
      alert('Order placed successfully!');
    } catch (error) {
      alert('Failed to process order. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='checkout-container'>
      <h1>Checkout</h1>
      <div className='checkout-content'>
        <div className='order-summary'>
          <h2>Order Summary</h2>
          {/* Add order summary content */}
        </div>
        <form className='checkout-form' onSubmit={handleSubmit}>
          <div className='form-group'>
            <label htmlFor='name'>Full Name:</label>
            <input
              type='text'
              id='name'
              name='name'
              value={formData.name}
              onChange={handleChange}
              placeholder='Enter your name'
              required
            />
          </div>
          <div className='form-group'>
            <label htmlFor='email'>Email:</label>
            <input
              type='email'
              id='email'
              name='email'
              value={formData.email}
              onChange={handleChange}
              placeholder='Enter your email'
              required
            />
          </div>
          <div className='form-group'>
            <label htmlFor='address'>Shipping Address:</label>
            <textarea
              id='address'
              name='address'
              value={formData.address}
              onChange={handleChange}
              placeholder='Enter your address'
              required
            ></textarea>
          </div>
          <div className='form-row'>
            <div className='form-group'>
              <label htmlFor='city'>City:</label>
              <input
                type='text'
                id='city'
                name='city'
                value={formData.city}
                onChange={handleChange}
                required
              />
            </div>
            <div className='form-group'>
              <label htmlFor='zipCode'>ZIP Code:</label>
              <input
                type='text'
                id='zipCode'
                name='zipCode'
                value={formData.zipCode}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className='form-group'>
            <label>Payment Method:</label>
            <div className='payment-options'>
              <label>
                <input
                  type='radio'
                  name='paymentMethod'
                  value='credit'
                  checked={formData.paymentMethod === 'credit'}
                  onChange={handleChange}
                />
                Credit Card
              </label>
              <label>
                <input
                  type='radio'
                  name='paymentMethod'
                  value='paypal'
                  checked={formData.paymentMethod === 'paypal'}
                  onChange={handleChange}
                />
                PayPal
              </label>
            </div>
          </div>
          <button type='submit' className='submit-btn' disabled={isLoading}>
            {isLoading ? 'Processing...' : 'Place Order'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Checkout;
